module.exports = {"340602001":"高岳街道","340602002":"矿山集街道","340602100":"朔里镇","340602101":"石台镇","340602102":"段圆镇","340602400":"淮北杜集经济开发区"}


//////////////////
// WEBPACK FOOTER
// ./src/town/340602.json
// module id = 992
// module chunks = 0